import type { ComponentType } from "react";

const NAMED_EXPORTS = [
  "AINAChatBot",
  "AinaApp",
  "AinaWebApp",
  "AINAWebApp",
  "App",
] as const;

/**
 * Picks the root React component from the AINA remote (export name may vary by release).
 */
export function resolveAinaExport(
  mod: Record<string, unknown>,
): ComponentType<Record<string, unknown>> {
  for (const key of NAMED_EXPORTS) {
    const v = mod[key];
    if (typeof v === "function") {
      return v as ComponentType<Record<string, unknown>>;
    }
  }
  if (typeof mod.default === "function") {
    return mod.default as ComponentType<Record<string, unknown>>;
  }
  throw new Error(
    "[oaStudentWeb] AINA remote: expected a component export (AINAChatBot, AinaApp, App, or default).",
  );
}
